(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../path/apply'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../path/apply'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.apply);
    global.convert = mod.exports;
  }
})(this, function (exports, _apply) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.convert = undefined;


  var makeOperation = function makeOperation(updater) {
    return function (obj, prop, value) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      obj[prop] = updater.apply(undefined, [value].concat(args));
    };
  };

  /**
   * Wraps an <code>updater</code> function, returning a new function taking <code>object</code>, <code>path</code> and <code>…args</code> as parameters.<br/>
   * The <code>updater</code> function is invoked with <code>value</code> and <code>…args</code>.<br/>
   * Be carefull, the <code>updater</code> function must not mutate its <code>value</code> argument.
   * @memberof core
   * @param {function} updater The updater function.
   * @return {function} Returns the wrapped function.
   * @example <caption>Wrapping an updater</caption>
   * const inc = (v, i = 1) => v + i // this function increments a number with an optional value which defaults to 1
   * const incProp = convert(inc)
   * const object = { nested: { prop: 4 } }
   * incProp(object, 'nested.prop') // => { nested: { prop: 5 } }
   * incProp(object, 'nested.prop', 2) // => { nested: { prop: 6 } }
   * @see {@link core.update|update} for more information.
   * @since 1.0.0
   */
  var convert = function convert(updater) {
    return (0, _apply.apply)(makeOperation(updater));
  };

  exports.convert = convert;
});